import { Outlet, useSearchParams, useLocation } from "react-router-dom";

export default function AuthLayout() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isCustomerPortal = searchParams.get("portal") === "customer";
  const isCompanyRegister = location.pathname === "/company-register";
  const isRegister = location.pathname === "/register";

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <div className={`w-full px-4 ${isCompanyRegister ? 'max-w-4xl' : 'max-w-md'}`}>
        {/* Logo - company-register, register 페이지에서는 숨김 */}
        {!isCompanyRegister && !isRegister && (
          <div className="mb-8 flex flex-col items-center">
            <picture>
              <source srcSet="/icons/hc_02.svg" media="(prefers-color-scheme: dark)" />
              <img src="/icons/hc_01.svg" alt="HubCore" className="h-12 w-auto" />
            </picture>
            <p className="mt-2 text-sm text-muted-foreground">
              {isCustomerPortal ? "고객 케어 포털" : "통합 업무 플랫폼"}
            </p>
          </div>
        )}

        {/* Auth form container */}
        <div className={isCompanyRegister ? 'rounded-lg border bg-card p-8 shadow-lg' : 'rounded-lg border bg-card p-8 shadow-lg'}>
          <Outlet />
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} HubCore by Think-Ai. All rights reserved.
        </div>
      </div>
    </div>
  );
}
